import * as React from 'react';
import {useColorMode} from '@chakra-ui/react';
export const IconGithub = (props: React.SVGProps<SVGSVGElement>) => {
  const {colorMode} = useColorMode();
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={20}
      height={20}
      viewBox="0 0 20 20"
      {...props}>
      <path fill="none" d="M0 0h20v20H0z" />
      <path
        fill={colorMode === 'light' ? '#222222' : '#ffffff'}
        fillRule="evenodd"
        d="M20 10a10 10 0 10-13.254 9.459.961.961 0 00.515-.745c0-.55-.012-1.965-.012-1.965a6.944 6.944 0 01-1.054.074 2.264 2.264 0 01-2.289-1.545 2.712 2.712 0 00-1.124-1.331c-.259-.168-.318-.364-.019-.419 1.381-.259 1.735 1.558 2.658 1.848a2.593 2.593 0 001.926-.154 2 2 0 01.794-1.288c-2.347-.225-3.739-1.035-4.46-2.339l-.078-.145-.181-.414-.054-.149a7 7 0 01-.326-2.265 3.868 3.868 0 011.1-2.87 4.008 4.008 0 01.174-2.882s1.016-.21 2.936 1.158a10.708 10.708 0 015.129-.1c.8-.53 2.28-1.283 2.874-1.071a3.718 3.718 0 01.211 2.66 4.647 4.647 0 011.255 3.314 8.6 8.6 0 01-.258 2.058l-.086.294s-.05.139-.1.271l-.064.145c-.7 1.521-2.124 2.089-4.431 2.325.747.469.961 1.056.961 2.645s-.021 1.8-.016 2.169a1.012 1.012 0 00.495.731A10 10 0 0020 10z"
      />
    </svg>
  );
};
